import React, {Component} from 'react';
import PropTypes from 'prop-types';

import styles from './map.pcss';
import { qaReportDirectionsClick, qaReportSiteClick } from '../utils/data/analytics';

const PopupContent = (props) => {
	const handleMapsLink = () => {
		qaReportDirectionsClick(props.locationTitle);
	};
	const handleSiteLink = () => {
		qaReportSiteClick(props.locationTitle);
	};
	return (
		<div className={styles.mapMarker}>
			{props.onCloseClick &&
			<button className={styles.mapMarkerClose} onClick={props.onCloseClick}>
				<span className="a11y-visual-hide">Close</span>
			</button>
			}
			<div className={styles.mapMarkerLocation} dangerouslySetInnerHTML={{__html:props.locationTitle}} />
			{props.locationTelephone &&
			<div>
				<a href="tel:{props.locationTelephone}" className={styles.mapMarkerTelephone}>
					{props.locationTelephone}
				</a>
			</div>
			}
			{ (props.locationAddressText && props.locationAddressUrl) &&
			<div>
				<a href={props.locationAddressUrl} className={styles.mapMarkerAddressLink} target="_blank" onClick={handleMapsLink}>
					{props.locationAddressText}
				</a>
			</div>
			}
			{(props.locationSiteText && props.locationSiteUrl) &&
			<div>
				<a href={props.locationSiteUrl} className={styles.mapMarkerSiteLink} target="_blank" onClick={handleSiteLink}>
					{props.locationSiteText}
				</a>
			</div>
			}
		</div>
	);
};

PopupContent.defaultProps = {
	onCloseClick: null,
	locationAddressText: 'Get Directions',
	locationSiteText: 'Visit Website',
	locationSiteUrl: null,
	locationAddressUrl: null,
	locationTelephone: null,
};

PopupContent.propTypes = {
	locationTitle: PropTypes.string.isRequired,
	onCloseClick: PropTypes.func,
	locationAddressText: PropTypes.string,
	locationSiteText: PropTypes.string,
	locationSiteUrl: PropTypes.string,
	locationAddressUrl: PropTypes.string,
	locationTelephone: PropTypes.string,
};

export default PopupContent;



// WEBPACK FOOTER //
// ./src/components/map-popup-contents.js